var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadedCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.125C4.65117 1.125 1.125 4.65117 1.125 9C1.125 13.3488 4.65117 16.875 9 16.875C13.3488 16.875 16.875 13.3488 16.875 9C16.875 4.65117 13.3488 1.125 9 1.125ZM9 15.5391C5.38945 15.5391 2.46094 12.6105 2.46094 9C2.46094 5.38945 5.38945 2.46094 9 2.46094C12.6105 2.46094 15.5391 5.38945 15.5391 9C15.5391 12.6105 12.6105 15.5391 9 15.5391Z",
    fill: "#1EA97C",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 2.46094C5.38945 2.46094 2.46094 5.38945 2.46094 9C2.46094 12.6105 5.38945 15.5391 9 15.5391C12.6105 15.5391 15.5391 12.6105 15.5391 9C15.5391 5.38945 12.6105 2.46094 9 2.46094ZM12.3996 6.42832L8.69766 11.5611C8.64592 11.6334 8.57771 11.6922 8.49868 11.7328C8.41966 11.7734 8.3321 11.7946 8.24326 11.7946C8.15442 11.7946 8.06686 11.7734 7.98784 11.7328C7.90882 11.6922 7.84061 11.6334 7.78887 11.5611L5.59863 8.52363C5.53184 8.43047 5.59863 8.30039 5.71289 8.30039H6.5373C6.71836 8.30039 6.88711 8.38828 6.99258 8.53418L8.24414 10.2709L11.0074 6.43887C11.1129 6.29121 11.2834 6.20508 11.4627 6.20508H12.2871C12.4014 6.20508 12.4682 6.33516 12.3996 6.42832Z",
    fill: "#1EA97C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2871 6.20508H11.4627C11.2834 6.20508 11.1129 6.29121 11.0074 6.43887L8.24412 10.2709L6.99256 8.53418C6.88709 8.38828 6.71834 8.30039 6.53729 8.30039H5.71287C5.59861 8.30039 5.53181 8.43047 5.59861 8.52363L7.78885 11.5611C7.84059 11.6334 7.9088 11.6922 7.98782 11.7328C8.06685 11.7734 8.15441 11.7946 8.24325 11.7946C8.33209 11.7946 8.41965 11.7734 8.49867 11.7328C8.57769 11.6922 8.6459 11.6334 8.69764 11.5611L12.3996 6.42832C12.4682 6.33516 12.4014 6.20508 12.2871 6.20508Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadedCheck);
export default __webpack_public_path__ + "static/media/readed-check.4c4b3df06ba9a371f974d27091fc3951.svg";
export { ForwardRef as ReactComponent };